<template>
  <div v-if="address" class="address-card" data-qa="addressCard">
    <div class="address-card__address">
      <p
        v-if="address.Line1"
        class="address-card__address-line address-card__address-line--line1"
      >
        {{ address.Line1 }}
      </p>
      <p
        v-if="address.Line2"
        class="address-card__address-line address-card__address-line--line2"
      >
        {{ address.Line2 }}
      </p>
      <p
        v-if="address.Line3"
        class="address-card__address-line address-card__address-line--line3"
      >
        {{ address.Line3 }}
      </p>
      <p
        v-if="address.Line4"
        class="address-card__address-line address-card__address-line--line4"
      >
        {{ address.Line4 }}
      </p>
      <p
        v-if="address.Line5"
        class="address-card__address-line address-card__address-line--line5"
      >
        {{ address.Line5 }}
      </p>
      <p
        v-if="address.City"
        class="address-card__address-line address-card__address-line--posttown"
      >
        {{ address.City }}
      </p>
      <p
        v-if="address.Province"
        class="address-card__address-line address-card__address-line--county"
      >
        {{ address.Province }}
      </p>
      <p
        v-if="address.PostalCode"
        class="address-card__address-line address-card__address-line--postcode"
      >
        {{ address.PostalCode }}
      </p>
    </div>
    <button
      ref="button"
      type="button"
      class="address-card__change-address"
      data-qa="changeAddress"
      @click="$emit('thrive-clear')"
    >
      Change address
    </button>
  </div>
</template>

<script>
export default {
  props: {
    address: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.$refs.button.focus();
  }
};
</script>

<style lang="scss">
.address-card {
  margin-top: 17px;
  margin-bottom: 15px;
  padding: 14px 16px 12px;
  color: #333;
  font-size: 16px;
  background-color: #f6f6f6;
  border: solid 1px #422d68;

  @media only screen and (max-width: 768px) {
    font-size: 14px;
  }

  &__address {
    margin-bottom: 15px;
    font-style: normal;

    &-line {
      margin-top: 0;
      margin-bottom: 0 !important;
      line-height: 1.5;
    }
  }

  &__change-address {
    margin: 0;
    padding: 0;
    font-weight: 500;
    background-color: transparent;
    border: none;
    border-bottom: 2px dotted transparent;
    outline: none;
    box-shadow: none;
    cursor: pointer;
    appearance: none;

    &:hover {
      text-decoration: underline;
    }

    &:focus {
      text-decoration: underline;
    }
  }
}
</style>
